import { QueryClient } from '@tanstack/react-query';

// Shared QueryClient for the whole app. Configured for a webapp where
// the backend never publishes stale data via cache — the client is the
// only cache layer (backend has no CDN or ETag caching, see
// docs/prds/2026-08-29-webapp-performance.md).
//
// staleTime defaults to 30s so back-navigation to a page you were just
// on paints instantly from cache and revalidates in the background.
// Individual queries can override — e.g. /profile uses staleTime: 0
// so a just-completed job's debit is not masked by a warm cache.
//
// refetchOnWindowFocus + refetchIntervalInBackground=false gives us
// visibility-pause for free on any useQuery with a refetchInterval.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 15 * 60_000,
      refetchOnWindowFocus: true,
      refetchIntervalInBackground: false,
      retry: (failureCount, err: unknown) => {
        const status = (err as { status?: number } | null)?.status;
        if (status === 401 || status === 402 || status === 403 || status === 404) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
